import { render, staticRenderFns } from "./Component_ShopDetail.vue?vue&type=template&id=032c2d26&scoped=true&"
import script from "./Component_ShopDetail.vue?vue&type=script&lang=js&"
export * from "./Component_ShopDetail.vue?vue&type=script&lang=js&"
import style0 from "./Component_ShopDetail.vue?vue&type=style&index=0&id=032c2d26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032c2d26",
  null
  
)

export default component.exports